import { render, staticRenderFns } from "./ChartAssetYear.vue?vue&type=template&id=2ff38127&scoped=true&"
import script from "./ChartAssetYear.vue?vue&type=script&lang=js&"
export * from "./ChartAssetYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff38127",
  null
  
)

export default component.exports